export default __webpack_public_path__ + "static/media/Snaresinselpinguin.8c1fc6d4.jpg";